// @flow
import React, { Fragment } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import './DateSelect.css';
import { format, parse, isValid } from 'date-fns';
import InputCreator, { $defaultInputProps } from '../../containers/ProductForm/InputCreator';

const parseDate = (input: String): ?Date => {
  const d = parse(input);
  return isValid(d) ? d : null;
};

const DateSelect = InputCreator(
  ({
    defaultInputProps,
    setAttributeValue,
  }: {
    defaultInputProps: $defaultInputProps,
    setAttributeValue: Function,
  }) => (
    <Fragment>
      <DayPickerInput
        placeholder="YYYY-MM-DD"
        format="YYYY-MM-DD"
        formatDate={date => format(date, 'YYYY-MM-DD')}
        parseDate={parseDate}
        onDayChange={selectedDay =>
          setAttributeValue(defaultInputProps.name, format(selectedDay, 'YYYY-MM-DD'))
        }
        dayPickerProps={{
          showWeekNumbers: false,
          todayButton: 'Today',
        }}
        {...defaultInputProps}
      />
    </Fragment>
  ));

export default DateSelect;



// WEBPACK FOOTER //
// ./src/components/DateSelect/index.js